import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f611fe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "checked", "name", "disabled"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))


const __default__ = {
    inheritAttrs: false
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'index',
  props: {
    label: {},
    modelValue: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any) {


const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass([[_ctx.$attrs.class,{'!text-gray-900':_ctx.modelValue}], "font-normal text-base text-gray-600 container whitespace-nowrap"])
  }, [
    _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
    _createElementVNode("input", {
      id: _ctx.$attrs.id as string,
      checked: _ctx.modelValue,
      type: "checkbox",
      name: _ctx.$attrs.name as string,
      class: "focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-primary-500",
      disabled: !!_ctx.$attrs.disabled,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).checked)))
    }, null, 40, _hoisted_1),
    _hoisted_2
  ], 2))
}
}

})